var cartData;
var selectItems = [];
var countAssemblies = 0;
var previouslyDisplayedContent = "";
var isRacketInCart = false;
var hasProcessingFee = false;

const LOCAL_STRAGE_KEY_IS_ASSEMBLING = "assemble__is_assembling";
const LOCAL_STRAGE_KEY_NOTE = "assemble__note";
const LOCAL_STRAGE_KEY_SET_TIME = "assemble__set_time";
const LOCAL_STRAGE_KEY_CART_DATA = "assemble__cart_data";
const LOCAL_STRAGE_KEY_INPUT_DATA = "assemble__input_data";
const LOCAL_STRAGE_KEY_DELIVERY_DATE = "assemble__delivery_date";

const RECOVERABLE_TIME = 30; //minute

const INPUT_KEY_SELECTBOX = "selectbox";
const INPUT_KEY_TEXTAREA = "textarea";

const COST_PRODUCT_VARIANT_ID = 43585667891445;
const COST_PRODUCT_PRICE = 770;

const IS_DEBUG = true;

/*
カートAPIよりカート情報を取得する
取得した情報で画面内容を更新する
*/
let callCartApi = (callback = null) => {
  fetch('/cart.js')
    .then(response => response.json())
    .then(data => {
      cartData = data;
      generateAssembleForm(data['items']);
    })
    .catch((error) => {
      window.alert('エラーが発生しました。ページを再読み込み（更新）してください');
    })
    .finally(() => {
      if (callback) {callback();}
    })
}

/*
カート内にラケットが含まれているか？
  */
let isRacketIncludedInCart = (items) => {
  for (const item of items) {
    if (item.product_type == "卓球ラケット") return true;
  }
  return false;
}

/*
加工賃の通知を表示する
*/
const displayAssmbleyCostInfo = () => {
  if (countAssemblies === 0) {
    displayToast(`<span style="color:black;">加工賃は発生しません</span>`);
  } else {
    displayToast(`<span style="color:black;">加工賃（${COST_PRODUCT_PRICE}）円が${countAssemblies}セット分加算されます</span>`);
  }
}

/*
加工賃の商品を擬似的に表示する
*/
const setAssemblyCostElm = (isSilence = false) => {
  
  if (!hasProcessingFee) { return; }

  let assemblyCostElm = document.getElementById("CartItem-AssembleCost");

  if (!isSilence) {
    displayAssmbleyCostInfo();
  }
  
  if (countAssemblies === 0) {
    assemblyCostElm.style.display = "none";
  } else {
    assemblyCostElm.style.display = "block";

    var quantityElm = document.querySelectorAll('#CartItem-AssembleCost .cart-item__quantity');
    if (quantityElm[0]) { quantityElm[0].innerHTML = countAssemblies; }

    var totalElm = document.querySelectorAll('#CartItem-AssembleCost .price');
    if (totalElm[0]) {
      var cost = countAssemblies * COST_PRODUCT_PRICE;
      totalElm[0].innerHTML = `&yen;${cost.toLocaleString()}`;
    }
  }
}

let resetNote = () => {
  
}

/*
加工情報のテキスト情報を生成
  */
let joinAssemblyInformation = (func = null, isSilence = false) => {
  var assemblyText = "";
  countAssemblies = 0;
  
  let assemblingCheckedRadioButton = document.querySelectorAll(`input[type='radio'][name='assembling']:checked`)[0];
  if (assemblingCheckedRadioButton.value == "yes") {
    assemblyText = "\n\n【以下が組み立ての要望になります】####\n\n";
    let setElms = document.querySelectorAll(`[id^='assemble-set']`);
    var i = 1;
  
    for (const setElm of setElms) {
      assemblyText = assemblyText + `【加工セット${i}】##` + "\n";
      var selectTags = setElm.querySelectorAll("select");
      var j = 0;
      var isSkip = false;
      for (const selectTag of selectTags) {
        if (j == 0) {
          if (selectTag.options[selectTag.selectedIndex].text.indexOf('ラケットが選択されていません') != -1) {
            isSkip = true;
            break;
          }

          countAssemblies += 1;
          assemblyText = assemblyText + "ラケット:##\n";
        } else if (j == 1) {
          assemblyText = assemblyText + "フォア面ラバー:##\n";
        } else if (j == 2) {
          assemblyText = assemblyText + "バック面ラバー:##\n";
        }
        assemblyText = assemblyText + selectTag.options[selectTag.selectedIndex].text +
          "##\n";
        j++;
      }
  
      if (isSkip) {
        assemblyText = assemblyText + "指定なし##\n";
      } else {
        var ta = setElm.querySelectorAll("textarea")[0];
        assemblyText = assemblyText + "備考:##\n";
        assemblyText = assemblyText + ta.value + "####\n\n-------------------------####\n\n";
      }
  
      i++;
    }
  }

  // var note = document.getElementById("Cart-note");
  // const body = JSON.stringify({
  //   attributes: {
  //     AssemblyInformation: note.value + "####\n\n" + assemblyText,
  //     note: note.value,
  //     AssemblyInformationWithoutNote: assemblyText,
  //   }
  // });

  var note = document.getElementById("Cart-note");

  // 備考欄に「加工情報あり」を追加する
  var tmpText = note.value;
  // 重複させないよう全消し（trimを考慮して改行の有り無しを行う）
  tmpText = tmpText.replace(/\n【加工情報あり】/g, ''); 
  tmpText = tmpText.replace(/【加工情報あり】/g, ''); 
  if (assemblyText != "") { tmpText = tmpText + "\n【加工情報あり】"; }
  
  console.log("1. ");
  console.log(assemblyText);
  console.log("2. ");
  console.log(tmpText);
  
  note.value = tmpText;
  
  const body = JSON.stringify({
    note: tmpText,
    attributes: {
      AssemblyInformation: note.value + "####\n\n" + assemblyText,
      AssemblyInformationWithoutNote: assemblyText,
    }
  });
  
  setAssemblyCostElm(isSilence);
  
  fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }})
    .then((response) => {
      
    })
    .then((state) => {
      
    })
    .catch((e) => {
      
    })
    .finally(() => {
      // note.value = tmpText;
      if (func) {func();}
    })
}

/*
加工情報の attributes を初期化する
*/
const resetAssemblyInformation = () => {
  resetLocalStrage();

  console.log("call resetAssemblyInformation");

  var note = document.getElementById("Cart-note");
  // 備考欄に「加工情報あり」を追加する
  var tmpText = note.value;
  // 重複させないよう全消し（trimを考慮して改行の有り無しを行う）
  tmpText = tmpText.replace(/\n【加工情報あり】/g, ''); 
  tmpText = tmpText.replace(/【加工情報あり】/g, ''); 
  note.value = tmpText;

  // 確認チェックを外す
  const assemblyConfirmed = document.getElementById("assemblyConfirmed");
  if (assemblyConfirmed) {
    assemblyConfirmed.checked = false;
  }
  
  const body = JSON.stringify({
    note: tmpText,
    attributes: {
      AssemblyInformation: "",
      note: "",
      AssemblyInformationWithoutNote: "",
    }
  });

  fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
}

/*
加工用のフォームを生成
  */
let generateAssembleForm = (items) => {
  var prd = {};
  var racketCount = 0;

  let assembleWrapper = document.getElementById("assemble-wrapper");
  if (isRacketIncludedInCart(items)) {
    assembleWrapper.disabled = false;
    assembleWrapper.style.display = "block";
  } else {
    assembleWrapper.disabled = true;
    assembleWrapper.style.display = "none";
  }

  selectItems = [];

  for (const item of items) {
    prd = {
      "title": item.title,
      "product_title": item.product_title,
      "variant_title": item.variant_title,
      "sku": item.sku,
      "quantity": item.quantity,
      "type": item.product_type,
      "is_racket": false,
      "is_rubber": false,
      "number": 0,
    };

    if (item.product_type == "卓球ラケット") {
      prd["is_racket"] = true;
      racketCount = racketCount + prd["quantity"];
    } else if (item.product_type == "卓球ラバー") {
      prd["is_rubber"] = true;
    }

    if (prd["is_racket"] || prd["is_rubber"]) {
      for (let i = 0; i < prd["quantity"]; i++) {
        var tmpPrd = Object.assign({}, prd);
        if (tmpPrd["sku"]) {
          // tmpPrd["title"] = `${tmpPrd["title"]} - ${tmpPrd["variant_title"]} (${tmpPrd["sku"]}) (${i+1}個目)`;
          tmpPrd["title"] = `${tmpPrd["title"]} (${tmpPrd["sku"]}) (${i+1}個目)`;
        } else {
          tmpPrd["title"] = `${tmpPrd["title"]} (${i+1}個目)`;
        }
        
        selectItems.push(tmpPrd);
      }
    }
  }

  let container = document.getElementById("parts-assemble-container");
  var containerForm = container.getElementsByTagName("form").item(0);

  // reset form.
  var cloneContainerForm = containerForm.cloneNode(false);
  containerForm.parentNode.replaceChild(cloneContainerForm, containerForm);
  containerForm = container.getElementsByTagName("form").item(0);

  let copySource = document.getElementById("parts-assemble-set-copy-source");

  if (racketCount == 0) {
    isRacketInCart = false;
    container.style.display = "none";
  } else {
    isRacketInCart = true;
    for (let i = 0; i < racketCount; i++) {
      let assembleSet = copySource.cloneNode(true);
      assembleSet.style.display = "block";
      assembleSet.id = `assemble-set-${i}`;
      assembleSet.getElementsByTagName("span")[0].innerText = `${i+1}`;
      var racketSelect = assembleSet.querySelectorAll('select[name="racket"]')[0];
      var inRubberSelect = assembleSet.querySelectorAll('select[name="in_rubber"]')[0];
      var outRubberSelect = assembleSet.querySelectorAll('select[name="out_rubber"]')[0];
      var noteTextarea = assembleSet.querySelectorAll('textarea')[0];

      racketSelect.addEventListener("change", checkSelectedValue);
      inRubberSelect.addEventListener("change", checkSelectedValue);
      outRubberSelect.addEventListener("change", checkSelectedValue);
      noteTextarea.addEventListener("change", debounce(checkSelectedValue, 300));

      for (const selectItem of selectItems) {
        if (selectItem["is_racket"]) {
          var op = document.createElement("option");
          op.text = selectItem["title"];
          op.value = selectItem["title"];
          racketSelect.appendChild(op);
        } else if (selectItem["is_rubber"]) {
          var op = document.createElement("option");
          op.text = selectItem["title"];
          op.value = selectItem["title"];
          inRubberSelect.appendChild(op);
          outRubberSelect.appendChild(op.cloneNode(true));
        }
      }

      containerForm.appendChild(assembleSet);
    }
  }

  setDeliverySelect();
  loadInput();
  updateAssembleErrorMessage();
}

/*
組み立て用フォームから商品セレクトボックスで選択された商品を選択済みとする
*/
let checkSelectedValue = (e) => {
  let regNotSelected = /選択されていません$/;

  let selectTags = document.getElementsByTagName("select");
  var selectedProductTitles = [];
  for (const selectTag of selectTags) {
    let selectedProductTitle = selectTag.options[selectTag.selectedIndex].text;

    if (!regNotSelected.test(selectedProductTitle)) {
      selectedProductTitles.push(selectTag.options[selectTag.selectedIndex].text);
    }
  }

  for (const selectTag of selectTags) {
    for (const op of selectTag.options) {
      if (selectedProductTitles.includes(op.value)) {
        op.disabled = true;
      } else {
        op.disabled = false;
      }
    }
  }

  joinAssemblyInformation();
}



/*
加工する、しないの選択によって要素の表示を切り替える
*/
const assemblingRadioButtonChenge = (button, isLoad = true) => {
  let container = document.getElementById("parts-assemble-container");
  let assemblyConfirmed = document.getElementById("assemblyConfirmed");
  let subtmitButton = document.getElementById("checkout");

  if (button.value == "yes") {
    joinAssemblyInformation();
    container.style.display = "block";
    subtmitButton.disabled = true;
    if (assemblyConfirmed.checked) {
      subtmitButton.disabled = false;
    } else {
      subtmitButton.disabled = true;
    }
  } else {
    resetAssemblyInformation();
    container.style.display = "none";
    subtmitButton.disabled = false;
  }

  updateAssembleErrorMessage();
}

/*
attributes へ設定するお届け日、時間の情報を更新する
  */
const updateDeliveryData = () => {
  let deliveryDateSelect = document.getElementById("delivery_date");
  let deliveryTimeSelect = document.getElementById("delivery_time");

  var deliveryDate = deliveryDateSelect.options[deliveryDateSelect.selectedIndex].value;
  var deliveryTime = deliveryTimeSelect.options[deliveryTimeSelect.selectedIndex].value;

  const body = JSON.stringify({
    attributes: {
      delivery_date: deliveryDate,
      delivery_time: deliveryTime,
    }
  });

  fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
}

/*
予約商品がカート内に含まれていないか確認する
  */
const isIncludePreorderProduct = () => {
  if (typeof GloboPreorderParams === 'undefined') { return false; }

  var preorderItemIds = [];
  for (let setting of GloboPreorderParams.preorderSettings["manual"]) {
    if (setting["profile"]["status"] == 1) preorderItemIds = preorderItemIds.concat(setting["productIds"]);
  }
  for (let settingKey in GloboPreorderParams.preorderSettings["products"]) {
    if (GloboPreorderParams.preorderSettings["products"][settingKey]["status"] == 1) preorderItemIds = preorderItemIds.concat([+settingKey]);
  }
  for (let cartItem of cartData["items"]) {
    if (preorderItemIds.includes(cartItem["product_id"])) {
      return true;
    }
  }
  
  return false;
}

/*
お届け日のセレクトボックスを生成
  */
const  createDeliverySelectElm = () => {
  const dayOfWeekStr = [ "（日）", "（月）", "（火）", "（水）", "（木）", "（金）", "（土）" ];

  let deliveryDateSelect = document.getElementById("delivery_date");
  deliveryDateSelect.addEventListener("change", updateDeliveryData);

  let deliveryTimeSelect = document.getElementById("delivery_time");
  deliveryTimeSelect.addEventListener("change", updateDeliveryData);
  
  var startDate = new Date();
  startDate.setDate(startDate.getDate() + 7);
  
  for (var i = 0;  i < 7;  i++) {
    var op = document.createElement("option");
    op.text = `${startDate.getFullYear()}/${startDate.getMonth() + 1}/${startDate.getDate()}${dayOfWeekStr[startDate.getDay()]}`;
    op.value = `${startDate.getFullYear()}${('0' + (startDate.getMonth() + 1)).slice(-2)}${('0' + startDate.getDate()).slice(-2)}`;
    deliveryDateSelect.appendChild(op); 
    
    startDate.setDate(startDate.getDate() + 1);
  }
}

/*
お届け日セレクトボックスの表示を設定
- 予約商品を含む場合にお届け日時を設定させない
  */
const setDeliverySelect = () => {
  // let deliveryDateContainer = document.getElementById("delivery_date_container");
  // if (isIncludePreorderProduct()) {
  //   deliveryDateContainer.style.display = "none";
  //   return;
  // } else {
  //   deliveryDateContainer.style.display = "block";
  //   updateDeliveryData();
  // }
  let deliveryDateContainer = document.getElementById("delivery_date_container");
  deliveryDateContainer.style.display = "block";
  updateDeliveryData();
}

/*
加工する、しないのラジオボタンによる制御を設定
assemblingRadioButtonChenge イベントリスナーへ登録
  */
const setupAssemblingRadioButtons = () => {
  let assemblingRadioButtons = document.querySelectorAll(`input[type='radio'][name='assembling']`);
  for (let button of assemblingRadioButtons) {
    button.addEventListener(`change`, (e) => {
      assemblingRadioButtonChenge(button);
    });
  }

  let subtmitButton = document.getElementById("checkout");
  let assemblyConfirmed = document.getElementById("assemblyConfirmed");

  // 初期状態を確認して処理
  const checkedRadio = document.querySelector(`input[type='radio'][name='assembling']:checked`);

  if (checkedRadio) {
    assemblingRadioButtonChenge(checkedRadio);
  } else {
    if (assemblyConfirmed.checked) {
      subtmitButton.disabled = false;
    } else {
      subtmitButton.disabled = true;
    }
    updateAssembleErrorMessage();
  }

  assemblyConfirmed.addEventListener('change', (e) => {
    const checkedRadio = document.querySelector(`input[type='radio'][name='assembling']:checked`);

    if (checkedRadio && checkedRadio.value === "yes") {
      if (assemblyConfirmed.checked) {
        subtmitButton.disabled = false;
      } else {
        subtmitButton.disabled = true;
      }
    }

    updateAssembleErrorMessage();
  });
}

/*
加工賃となる商品をカートに追加、削除する
*/
const addCostProduct = (callback) => {
  var isCostProductInclude = false;
  var line = 0;
  var itemKey = "";

  cartData.items.forEach((item, index) => {
    if (item["id"] == COST_PRODUCT_VARIANT_ID) {
      isCostProductInclude = true;
      line = index;
      itemKey = item["key"];
    }
  })

  // 注意点：
  // cart change api が２回呼ばないと反映されない為、バグと理解し解決するまではそのようにする
  // https://community.shopify.com/c/shopify-apis-and-sdks/cart-api-update-not-working-reliably/td-p/991838
  if (isCostProductInclude) {
    const body = JSON.stringify({
      id: itemKey,
      quantity: countAssemblies,
    });

    fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
      .then((response) => {
        
        // 同じ処理を２度行う
        fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
        .then((response) => {
        }).catch((e) => {
          console.log(e);
        }).finally(() => {
          callback();
        }); 
      })
      .catch((e) => {
        console.log(e);
      }).finally(() => {
        // 本来はここで callback を行う
        // callback();
      }); 
  } else {
    const body = JSON.stringify({
      items: [{
          id: COST_PRODUCT_VARIANT_ID,
          quantity: countAssemblies,
        }] 
    });
    
    fetch(`${routes.cart_add_url}`, {...fetchConfig(), ...{ body }})
      .then((response) => {
      })
      .catch((e) => {
        console.log(e);
      }).finally(() => {
        callback();
      }); 
  }
}

/*
サブミットボタンの挙動を設定
  */
const setupSubmitButton = () => {
  let submitButton = document.getElementById("checkout");
  
  submitButton.addEventListener("click", (e) => {
    e.preventDefault();
    
    fetch('/cart.js')
      .then(response => response.json())
      .then(data => {
        cartData = data;
        saveInput();
        joinAssemblyInformation(() => {
          
          if (hasProcessingFee) {
            addCostProduct(() => {
              submitButton.click();
            });
          } else {
            submitButton.click();
          }
          
        }, true);
      })
      .catch((e) => {
        console.log(e);
        window.alert('エラーが発生しました。ページを再読み込み（更新）してください');
      });
  }, {once: true});
}

/*
使用している LocalStrage を初期化する
  */
const resetLocalStrage = () => {
  localStorage.removeItem(LOCAL_STRAGE_KEY_IS_ASSEMBLING);
  localStorage.removeItem(LOCAL_STRAGE_KEY_SET_TIME);
  localStorage.removeItem(LOCAL_STRAGE_KEY_CART_DATA);
  localStorage.removeItem(LOCAL_STRAGE_KEY_INPUT_DATA);
  localStorage.removeItem(LOCAL_STRAGE_KEY_DELIVERY_DATE);
}

/*
処理上で生成したinput要素の値を保存する
  */
const saveInput = () => {
  if (window.localStorage) {
    resetLocalStrage();

    const deliveryDateSelect = document.getElementById("delivery_date");
    localStorage.setItem(LOCAL_STRAGE_KEY_DELIVERY_DATE, deliveryDateSelect.selectedIndex);

    let assemblingCheckedRadioButton = document.querySelectorAll(`input[type='radio'][name='assembling']:checked`)[0];
    localStorage.setItem(LOCAL_STRAGE_KEY_IS_ASSEMBLING, assemblingCheckedRadioButton.value);
    
    let today = new Date();
    localStorage.setItem(LOCAL_STRAGE_KEY_SET_TIME, today.toString());

    let json = JSON.stringify(cartData.items);
    localStorage.setItem(LOCAL_STRAGE_KEY_CART_DATA, json);

    if (assemblingCheckedRadioButton.value == "no") {
      return;
    } else {
      let setElms = document.querySelectorAll(`[id^='assemble-set']`);
      var selectedItems = {};
      for (const setElm of setElms) {
        selectedItems[setElm.id] = {
          selectbox: [],
          textarea: ""
        };
  
        var selectTags = setElm.querySelectorAll("select");
        for (const selectTag of selectTags) {
          selectedItems[setElm.id][INPUT_KEY_SELECTBOX].push(selectTag.selectedIndex);
        }
  
        var textareas = setElm.querySelectorAll("textarea");
        for (const textarea of textareas) {
          selectedItems[setElm.id][INPUT_KEY_TEXTAREA] = textarea.value;
        }
      }
  
      let selectedItemsJson = JSON.stringify(selectedItems);
      localStorage.setItem(LOCAL_STRAGE_KEY_INPUT_DATA, selectedItemsJson);
    }
  }
}

/*
処理上で生成したinput要素の値を復元する
  */
const loadInput = () => {
  if (window.localStorage) {
    let setTimeStr = localStorage.getItem(LOCAL_STRAGE_KEY_SET_TIME);
    let inputDataStr = localStorage.getItem(LOCAL_STRAGE_KEY_INPUT_DATA);
    let cartDataStr = localStorage.getItem(LOCAL_STRAGE_KEY_CART_DATA);
    let isAssembling = localStorage.getItem(LOCAL_STRAGE_KEY_IS_ASSEMBLING);
    let deliveryDate = localStorage.getItem(LOCAL_STRAGE_KEY_DELIVERY_DATE);

    // 保存内容がない場合は終了
    if (setTimeStr == null) {
      resetLocalStrage();
      return;
    }

    // カート情報が異なっている場合は終了
    let cartDataStrParsed = JSON.parse(cartDataStr);
    var isHit = false;
    
    for (let item of cartData.items) {
      // 加工賃はチェックの対象としない
      if (item["product_title"].indexOf('加工賃') != -1) {
        continue;
      }
      
      isHit = false;
      for (let target of cartDataStrParsed) {
        if (item["id"] == target["id"] && item["quantity"] == target["quantity"]) {
          isHit = true;
        }
      }
      if (!isHit) break;
    }
    
    if (!isHit) {
      resetLocalStrage();
      return;
    }

    // 一定時間以上前の情報は復元しない
    let today = new Date();
    let setTime = new Date(setTimeStr);
    let diff = (today - setTime) / 1000 / 60;
    if (diff >= RECOVERABLE_TIME) {
      resetLocalStrage();
      return;
    }

    // 復元処理
    const deliveryDateSelect = document.getElementById("delivery_date");
    deliveryDateSelect.options[deliveryDate].selected = true;
    
    let assemblingRadioButtons = document.querySelectorAll(`input[type='radio'][name='assembling']`);
    for (let button of assemblingRadioButtons) {
      if (button.value == isAssembling) {
        button.checked = true;
        assemblingRadioButtonChenge(button);
      }
    }
  
    if (inputDataStr == null) return; 
    
    let parsedInputData = JSON.parse(inputDataStr);
    let setElms = document.querySelectorAll(`[id^='assemble-set']`);
    
    setElms.forEach((setElm, i) => {
      var targetInputTag = parsedInputData[setElm.getAttribute("id")];
      
      var selectTags = setElm.querySelectorAll("select");
      selectTags.forEach((selectTag, j) => {
        selectTag.options[targetInputTag[INPUT_KEY_SELECTBOX][j]].selected =
          true;
      });
  
      var textAreas = setElm.querySelectorAll("textarea");
      textAreas.forEach((textArea, j) => {
        textArea.value = targetInputTag[INPUT_KEY_TEXTAREA];
      });
    });
  
    checkSelectedValue();
  }
}

/*
トーストを表示する
PATH: /assets/jsframe.js
MAMO: https://github.com/riversun/JSFrame.js
  */
const displayToast = (text) => {
  // if (previouslyDisplayedContent == text) { 
  //   return;
  // } else {
  //   previouslyDisplayedContent = text;
  // }
  
  const jsFrame = new JSFrame();
  jsFrame.showToast({
    html: "<span style='color: black;'>" + text + "</span>",
    align: 'top',
    width: 350,
    style: {
      backgroundColor: 'rgba(255,255,255,1.0)',
    },
    duration: 3000
  });
}

const checkHasProcessingFee = () => {
  const hasprocessingfeeElm = document.getElementById("hasprocessingfee");
  if (hasprocessingfeeElm.value == "true") {
    hasProcessingFee = true;
  } else {
    hasProcessingFee = false;
  }
}

const main = () => {
  createDeliverySelectElm();
  checkHasProcessingFee();

  callCartApi(() => {
    if (isRacketInCart) {
      // 独自で追加したイベント updateQuantityComplete
      // カート画面での数量を変更された際に発火する
      document.addEventListener('updateQuantityComplete', (event) => {
        resetAssemblyInformation();
        callCartApi();
        displayToast('加工内容の選択がリセットされました。');
      });
      
      setupAssemblingRadioButtons();
      setupSubmitButton();
    }
  });
}

document.addEventListener('DOMContentLoaded', function() {
  main();
});


// 260318購入可能数制限の内製化対応
const updateAssembleErrorMessage = () => {
  const messageElm = document.getElementById("cart-errors-assemble");
  const submitButton = document.getElementById("checkout");
  const assemblyConfirmed = document.getElementById("assemblyConfirmed");
  const checkedRadio = document.querySelector(`input[type='radio'][name='assembling']:checked`);

  if (!messageElm || !submitButton) return;

  // ラケットがカートにないならメッセージ不要
  if (!isRacketInCart) {
    messageElm.textContent = "";
    return;
  }

  // 加工オプションの選択誘導
  if (!checkedRadio) {
    messageElm.textContent = "加工の有無を選択してください。";
    return;
  }
  if (checkedRadio.value === "no") {
    messageElm.textContent = "";
    return;
  }

  // 確認チェックが未完了なら表示
  if (checkedRadio.value === "yes" && assemblyConfirmed && !assemblyConfirmed.checked) {
    messageElm.textContent = "加工内容を選択し、「上記の加工内容を確認しました」にチェックを入れてください。";
    return;
  }

  // 条件クリア時は消す
  messageElm.textContent = "";
}